import { DevOpsActionAndParameter } from "../models/DevOpsActionAndParameter";

export class GetDevOpsActionsAndParametersResponse {
    devOpsActionsAndParameters?: DevOpsActionAndParameter[];
}